module.exports = __webpack_public_path__ + "4f69bbe94e4d695fe43e1a7120a20752.png";